<template>
  <div>
    <component :is="sectionPracticeComponent" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useContextStore } from 'src/store'
import SectionPracticeMobile from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/SectionPracticeMobile.vue'
import SectionPracticeDesktop from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/SectionPracticeDesktop.vue'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

const { context }: ContextStore = useContextStore()

const isMobile = computed(() => context?.flavour === 'mobile')
const sectionPracticeComponent = computed(() => (isMobile.value ? SectionPracticeMobile : SectionPracticeDesktop))
</script>
